import React from "react";
import { connect } from "react-redux";
import axios from "axios";

import EntityContent from './EntityContent';

import { getTransaction, getMoreTransaction } from '../../../actions/transactionActions';
import { getCompanyTransactions, getCompanyInvoices } from '../../../actions/companyActions';
import { getHeader } from "../../../helper";

class Balance extends React.Component {

    componentWillMount() {
        const { dispatch } = this.props;

        if(!this.props.selectedCompany) return false;

        dispatch(getCompanyTransactions(this.props.selectedCompany.id))
        dispatch(getCompanyInvoices(this.props.selectedCompany.id));
    }

    componentDidUpdate(prevProps) {
        const {selectedCompany} = this.props;

        if(
            selectedCompany && prevProps.selectedCompany &&
            selectedCompany.id !== prevProps.selectedCompany.id
        ) {
            this.props.dispatch(getCompanyTransactions(selectedCompany.id))
            this.props.dispatch(getCompanyInvoices(selectedCompany.id));
        }
    }

    handleMoreRecords(nextPage) {
        if(!nextPage) return false;

        const { dispatch } = this.props;
        let headers = getHeader()

        dispatch(getMoreTransaction(nextPage, {
            params: {},
            headers
        }));
    }

    render() {

        const {
            transactions,
            session,
            company:{companies},
            showBalancePopup,
            currentAdmin
        } = this.props;
        const companyInvoices = this.props.company.invoices;
        const companyTransactions = this.props.company.transactions;
        const { isFetchingMore } = transactions;
        const moreRecords = transactions.data.next || null;
        const moreCompanyRecords = companyTransactions.data.next || null;
        const { currentUser } = session;

        return(
            <div className="menu-content-balance menu-content-item tab-parent screen-bottom-block">
                <div className="rounded-white-block">

                    <div className="white-block-content">

                        <EntityContent
                            companies={companies}
                            transactions={companyTransactions}
                            companyInvoices={companyInvoices}
                            currentUser={currentUser}
                            handleCompany={this.props.handleCompany}
                            selectedCompany={this.props.selectedCompany}
                            showBalancePopup={showBalancePopup}
                            currentAdmin={currentAdmin}
                            />
                    </div>
                </div>
                {
                    moreCompanyRecords ?
                    <div className="big-button without-shadow button-action" style={{height:"auto", textAlign:"center",marginTop:"30px",marginBottom:"30px"}}>
                        <button
                            className={isFetchingMore ? 'disabled' : ''}
                            onClick={() => this.handleMoreRecords(moreCompanyRecords)}>
                            {isFetchingMore ? 'Загружается...' : 'Загрузить еще'}
                        </button>
                    </div>
                    : ''
                }
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state
    };
};
  
export default connect(mapStateToProps)(Balance);


// WEBPACK FOOTER //
// ./src/components/Account/Balance/EntityBalance.js